import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const inputWidth = '176px'

interface AddChannelStyleProps {
  canDelete?: boolean
}
const useStyles = makeStyles<Theme, AddChannelStyleProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    paddingLeft: ({ canDelete }) => !canDelete && 8
  },

  input: {
    border: 'none',
    height: '17px',
    borderBottom: '1px solid #8F8F8F',
    padding: '0',
    paddingBottom: '8px',
    outline: 'none',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&::placeholder': {
      fontSize: theme.size.sm,
      color: '#8F8F8F !important',
      opacity: '0.5'
    }
  },

  label: {
    width: '100%',
    maxWidth: '80px',
    marginRight: '16px',
    fontSize: theme.size.sm,
    color: '#8F8F8F',

    '&::placeholder': {
      fontSize: theme.size.sm,
      color: '#8F8F8F !important',
      opacity: '0.5'
    }
  },

  phoneInputContainer: {
    display: 'inline-flex !important',
    borderBottom: '1px solid #8F8F8F',
    paddingBottom: '8px',
    position: 'relative',

    '& > input': {
      height: '17px !important',
      width: '100% !important',
      maxWidth: inputWidth,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    '& .form-control': {
      border: 'none !important',
      paddingLeft: '40px'
    },

    '& .flag-dropdown': {
      pointerEvents: 'none',
      border: 'none !important',
      height: '17px',
      backgroundColor: 'white !important'
    },

    '& .flag-dropdown > div': {
      padding: '0'
    }
  },

  email: {
    width: '100%',
    maxWidth: inputWidth
  }
}))

export default useStyles
